<template>
  <v-dialog v-model="showVoucherDialog" persistent max-width="320" v-if="!showFinishDialog">
    <v-card>
      <v-card-title>
        <h3 class="subtitle-1">{{ $t('bounties.voucherModalTitle') }}</h3>
        <h4 class="title">{{ bounty.name }}</h4>
      </v-card-title>

      <v-card-text>
        <v-row justify="center">
          <v-avatar class="reward-image" size="100"><img v-if="bounty.image" :src="bounty.image" height="80" width="80"></v-avatar>
        </v-row>

        <v-row v-if="!countdown.finished">
          <v-col>
            <div class="text-center">
              <div class="body-2 mb-2">{{ $t('bounties.validVoucherTillText') }}</div>
              <span class="body-1 text--primary" v-if="countdown.days > 0">
                {{ $tc('bounties.voucherCountdown', countdown.days, {days: countdown.days}) }}
              </span>
              <br>
              <span class="title text--primary">{{ countdown.hours | leadingZero }}:{{ countdown.minutes | leadingZero }}:{{ countdown.seconds | leadingZero }}</span>
            </div>
            <div class="mt-4 text-center">
              <div class="body-2">{{ $t('bounties.voucherModalActiveCountdownDescription') }}</div>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="text-center">
              <h3 class="title">{{ $t('bounties.voucherModalVoucherExpired') }}</h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <!--  TODO: Barcode -->

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="showFinishAlertBox" v-if="!countdown.finished">{{ $t('bounties.voucherModalInvalidateButtonText') }}</v-btn>
        <v-btn color="primary" text @click="showFinishAlertBox" v-else>{{ $t('bounties.voucherModalCloseButtonText') }}</v-btn>

        <v-btn color="primary" text @click="onFinishPressed" v-if="redeemVoucherLater && !countdown.finished">{{ $t('bounties.voucherModalRedeemLaterText') }}</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showFinishDialog" persistent max-width="320" v-else>
    <v-card>
      <v-card-title class="headline">{{ $t('bounties.voucherModalFinishedTitle') }}</v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="showFinishDialog = false">{{ $t('bounties.voucherModalFinishedCancel') }}</v-btn>
        <v-btn color="primary" text @click="onFinishPressed">{{ $t('bounties.voucherModalFinishedSubmit') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {storage} from '@/store';
  import {getActiveVoucher, getOverallSeconds} from '@/utils/getActiveVoucher';

  export default {
    name: 'VoucherDialog',
    props: ['bounty', 'showVoucherDialog'],
    data() {
      return {
        showFinishDialog: false,
        redeemVoucherLater: false,
        countdown: {
          days: Math.floor(this.overallSeconds / (24 * 3600)),
          hours: Math.floor(this.overallSeconds % (24 * 3600) / 3600),
          minutes: Math.floor((this.overallSeconds % (24 * 3600) % 3600) / 60),
          seconds: Math.floor((this.overallSeconds % (24 * 3600) % 3600 % 3600 % 60)),
          finished: undefined
        },
        countdownInterval: null
      }
    },
    mounted() {
      let voucher = getActiveVoucher();
      if (voucher) {
        let {remainingSeconds, ts} = voucher;
        this.setCountdown(remainingSeconds, ts)
      } else {
        console.warn('Could not get remainingSeconds from AsyncStorage');
        this.countdown.finished = true;
      }
    },
    computed: {
      overallSeconds() {
        return getOverallSeconds();
      }
    },
    // TODO: Barcode
    methods: {
      showFinishAlertBox() {
        if (!this.countdown.finished) {
          this.showFinishDialog = true;
        } else {
          this.onFinishPressed();
        }
      },
      onFinishPressed() {
        storage.removeItem('activeVoucher');
        this.showFinishDialog = false;
        this.$emit('finish-pressed');
      },
      setCountdown(remainingSeconds, ts) {
        if (remainingSeconds <= 0) {
          clearInterval(this.countdownInterval);
          this.countdown = {
            days: 0, hours: 0, minutes: 0, seconds: 0, finished: true,
          };
        } else {
          this.countdown = {
            days: Math.floor(remainingSeconds / (24 * 3600)),
            hours: Math.floor(remainingSeconds % (24 * 3600) / 3600),
            minutes: Math.floor((remainingSeconds % (24 * 3600) % 3600) / 60),
            seconds: Math.floor((remainingSeconds % (24 * 3600) % 3600 % 3600 % 60)),
            finished: false,
          };
          if (!this.countdownInterval) {
            this.countdownInterval = setInterval(() => {
              const newDiff = Math.round(+new Date / 1000) - ts;
              const newRemainingSeconds = this.overallSeconds - newDiff;

              if (newRemainingSeconds < 0) {
                clearInterval(this.countdown);
                this.countdown.finished = true;
              } else {
                const days = Math.floor(newRemainingSeconds / (3600 * 24));
                const hours = Math.floor(newRemainingSeconds % (24 * 3600) / 3600);
                const minutes = Math.floor((newRemainingSeconds % (24 * 3600) % 3600) / 60);
                const seconds = newRemainingSeconds - days * 3600 * 24 - hours * 3600 - minutes * 60;

                this.countdown = {
                  days, hours, minutes, seconds, countdownFinished: false
                };
              }
            }, 1000);
          }
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.countdownInterval);
    }
  }
</script>

<style scoped lang="scss">
  .v-card__title {
    flex-wrap: wrap;
    h3 {
      width: 100%;
    }
  }
</style>
